import { Link } from 'react-router-dom';
import { business } from '../data/business';
import './LegalPage.css';

function ConsentPage() {
  return (
    <main className="legal-page">
      <div className="legal-page__inner">
        <p className="legal-page__eyebrow">필수 안내</p>
        <h1>개인정보 수집·이용 동의</h1>
        <p className="legal-page__lead">
          {business.productName} 부스 도입 문의 시 아래 개인정보를 수집·이용합니다.
        </p>

        <section>
          <h2>1. 수집 항목</h2>
          <ul>
            <li>이름</li>
            <li>전화번호</li>
            <li>주소(도입 예정 장소)</li>
          </ul>
        </section>

        <section>
          <h2>2. 수집·이용 목적</h2>
          <ul>
            <li>아이로그 부스 도입 문의 접수 및 회신</li>
            <li>도입 상담 일정 조율 및 관련 안내</li>
            <li>서비스 소개 자료 제공</li>
          </ul>
        </section>

        <section>
          <h2>3. 보유·이용 기간</h2>
          <p>
            문의 처리 완료 후 1년, 또는 관련 법령에 따른 보관 기간이 있을 경우 해당 기간까지
            보관합니다. 동의 철회 시 지체 없이 파기합니다.
          </p>
        </section>

        <section>
          <h2>4. 동의 거부 권리</h2>
          <p>
            귀하는 개인정보 수집·이용에 대한 동의를 거부할 수 있습니다. 다만 동의를 거부하실 경우
            도입 문의 접수 및 상담이 제한될 수 있습니다.
          </p>
        </section>

        <section>
          <h2>5. 관련 정책</h2>
          <p>
            자세한 내용은{' '}
            <Link to="/privacy">개인정보처리방침</Link> 및 <Link to="/terms">이용약관</Link>을
            확인해 주세요.
          </p>
        </section>

        <Link to="/" className="legal-page__back">
          ← 랜딩으로 돌아가기
        </Link>
      </div>
    </main>
  );
}

export default ConsentPage;
